const Menu = [
  { header: 'Giám sát' },
  {
    title: 'Bản đồ',
    group: 'apps',
    icon: 'map',
    name: 'map',
    url: '/map'
  },
  {
    title: 'Vùng giới hạn',
    group: 'apps',
    name: 'geofence',
    icon: 'golf_course',
    url: '/geofence'
  },
  { header: 'Tiện ích' },
  {
    title: 'Bảo trì - bảo dưỡng',
    group: 'apps',
    name: 'maintenance',
    icon: 'build',
    url: '/maintenance'
  },
  {
    title: 'Bản tin',
    group: 'apps',
    name: 'news',
    icon: 'email',
    url: '/news'
  },
  // {
  //   title: 'Báo cáo',
  //   group: 'apps',
  //   name: 'reporting',
  //   icon: 'bar_chart',
  //   url: '/reporting'
  // },
  { header: 'Báo cáo thống kê' },
  {
    title: 'Quãng đường di chuyển',
    group: 'reporting',
    name: 'daily',
    icon: 'show_chart',
    url: '/daily'
  },
  {
    title: 'Quãng đường theo xe',
    group: 'reporting',
    name: 'dailyByVehicle',
    icon: 'bar_chart',
    url: '/dailyByVehicle'
  },
  // {
  //   title: 'Báo cáo',
  //   group: 'reporting',
  //   component: 'reporting',
  //   icon: 'bar_chart',
  //   items: [
  //     { name: 'daily', title: 'Quãng đường di chuyển', component: 'daily' },
  //     { name: 'dailyByVehicle', title: 'Quãng đường theo xe', component: 'dailyByVehicle' },
  //   ]
  // },
  // {
  //   title: 'Cài đặt',
  //   group: 'apps',
  //   name: 'settings',
  //   icon: 'settings',
  //   url: '/settings'
  // },
];
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js